import { IComplaintAdapter } from './IComplaintAdapter';
import { ApiResponse } from '../../types/api';
import { Complaint, CreateComplaintDto, ComplaintFilter } from '../../types/complaint';
import { ApiClient } from '../apiClient';

export class LaravelComplaintAdapter implements IComplaintAdapter {
  async getComplaints(filter?: ComplaintFilter): Promise<ApiResponse<Complaint[]>> {
    const params = new URLSearchParams(filter as any).toString();
    return ApiClient.get<Complaint[]>(`/api/v1/complaints?${params}`);
  }

  async getComplaintById(id: string): Promise<ApiResponse<Complaint>> {
    return ApiClient.get<Complaint>(`/api/v1/complaints/${id}`);
  }

  async createComplaint(dto: CreateComplaintDto): Promise<ApiResponse<Complaint>> {
    return ApiClient.post<Complaint>('/api/v1/complaints', dto);
  }

  async updateStatus(id: string, statusName: string): Promise<ApiResponse<Complaint>> {
    return ApiClient.post<Complaint>(`/api/v1/complaints/${id}/status`, { status_name: statusName });
  }
}
